export default __webpack_public_path__ + "static/media/set_6_Link-5.17367224.svg";